import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, throwError } from 'rxjs';
import { map, catchError } from 'rxjs/operators';
import { AppErrors, NotFoundError } from '@fitness-force/errors';
import { CONST_URL_SEGEMENTS } from '@fitness-force/constants';
import { AccessRequest, Claim, EligibleClaimResponse } from '@fitness-force/models';
import { environment } from 'apps/ff-frontend/src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class ClaimService {
  constructor(private http: HttpClient) { }

  httpOptions = {
    headers: new HttpHeaders({
      'Content-Type': 'application/json'
    })
  };

  GetClaim(BASE_URL: string=environment.BASE_URL): Observable<Claim[]> {
    return this.http.get(BASE_URL + CONST_URL_SEGEMENTS.CLAIM.GET_CLAIM_TEMPLATES, {
      headers: this.httpOptions.headers
    }).pipe(map((res: any) => {
      if (res && res.items) {
        return res.items;
      } else {
        throwError;
      }
    }), catchError((error: Response) => {
      if (error.status === 404) {
        return throwError(() => new NotFoundError(error));
      }
      return throwError(() => new AppErrors(error));
    }));
  }

  GetEligibleTemplates(BASE_URL: string=environment.BASE_URL): Observable<EligibleClaimResponse> {
    return this.http.get(BASE_URL + CONST_URL_SEGEMENTS.CLAIM.GET_ELIGIBEL_TEMPLATES, {
      headers: this.httpOptions.headers
    }).pipe(map((res: any) => {
      return res;
    }), catchError((error: Response) => {
      if (error.status === 404) {
        return throwError(() => new NotFoundError(error));
      }
      return throwError(() => new AppErrors(error));
    }));
  }

  RequestAccess(tenantId:number,requestData: AccessRequest): Observable<Response> {
    return this.http
      .post(`${environment.BASE_URL}/tenants/${tenantId}/request_access`, requestData, { headers: this.httpOptions.headers })
      .pipe(
        map((res: any) => {
          return res;
        }),
        catchError((error: Response) => {
          if (error.status === 404) {
            return throwError(() => new NotFoundError(error));
          }
          return throwError(() => new AppErrors(error));
        })
      );
  }


  createTemplate(data: any) {
    return this.http
      .post(
        `${environment.BASE_URL}/claim_templates`,
        data,
        this.httpOptions
      )
      .pipe(
        map((res: any) => {
          return res;
        }),
        catchError((error: Response) => {
          if (error.status === 404) {
            return throwError(() => new NotFoundError(error));
          }
          return throwError(() => new AppErrors(error));
        })
      );
  }


  updateTemplate(claimId:number,data: any) {
    return this.http
      .put(
        `${environment.BASE_URL}/claim_templates/${claimId}`,
        data,
        this.httpOptions
      )
      .pipe(
        map((res: any) => {
          return res;
        }),
        catchError((error: Response) => {
          if (error.status === 404) {
            return throwError(() => new NotFoundError(error));
          }
          return throwError(() => new AppErrors(error));
        })
      );
  }


  getTemplate(claimId:number) {
    return this.http
      .get(
        `${environment.BASE_URL}/claim_templates/${claimId}`,
        this.httpOptions
      )
      .pipe(
        map((res: any) => {
          return res;
        }),
        catchError((error: Response) => {
          if (error.status === 404) {
            return throwError(() => new NotFoundError(error));
          }
          return throwError(() => new AppErrors(error));
        })
      );
  }



  markActive(claimTemplateId: number) {
    return this.http
      .post(
        `${environment.BASE_URL}/claim_templates/${claimTemplateId}/mark_as_active`,
        {},
        this.httpOptions
      )
      .pipe(
        map((res: any) => {
          return res;
        }),
        catchError((error: Response) => {
          if (error.status === 404) {
            return throwError(() => new NotFoundError(error));
          }
          return throwError(() => new AppErrors(error));
        })
      );
  }

  markInActive(claimTemplateId: number) {
    return this.http
      .post(
        `${environment.BASE_URL}/claim_templates/${claimTemplateId}/mark_as_inactive`,
        {},
        this.httpOptions
      )
      .pipe(
        map((res: any) => {
          return res;
        }),
        catchError((error: Response) => {
          if (error.status === 404) {
            return throwError(() => new NotFoundError(error));
          }
          return throwError(() => new AppErrors(error));
        })
      );
  }


}
